import React from 'react'
import { Box } from '@material-ui/core'
import GenericFilter from '../GenericFilter'
import { useAppState } from 'appContext'

const defaultValues = {
    text: '',
    checkbox: false,
    autocomplete: null,
    tree: null,
    checklist: [],
}

const FormsFilter = ({ filters }) => {
    const [state, dispatch] = useAppState()

    return (
        <>
            {filters.map((f) => (
                <Box key={f.name} padding="20px 20px 0px 20px">
                    <GenericFilter
                        value={state[f.contextProp] ?? defaultValues[f.type]}
                        onChange={(val) => {
                            dispatch({
                                type: 'SET_PROP',
                                payload: {
                                    key: f.contextProp,
                                    value: val,
                                },
                            })
                        }}
                        {...f}
                    />
                </Box>
            ))}
        </>
    )
}

export default FormsFilter
